import React from 'react';
import styled from 'styled-components';
import { Normalize } from 'styled-normalize';
import { WrapPageElementBrowserArgs } from 'gatsby';
import GlobalStyle from './styles/global';
import ErrorModal from './components/ErrorModal';
import { TIMESLOTSTODAY } from './helpers/urlHelper';
import { TextContext } from '@ingka/text';

// Skapa styles
import '@ingka/button/dist/style.css';
import '@ingka/choice/dist/style.css';
import '@ingka/focus/dist/style.css';
import '@ingka/forms/dist/style.css';
import '@ingka/hyperlink/dist/style.css';
import '@ingka/inline-message/dist/style.css';
import '@ingka/jumbo-button/dist/style.css';
import '@ingka/loading/dist/style.css';
import '@ingka/modal/dist/style.css';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/switch/dist/style.css';
import '@ingka/typography/dist/style.css';
import '@ingka/text/dist/style.css';
import '@ingka/price/dist/style.css';
import '@ingka/commercial-message/dist/style.css';
import '@ingka/price-module/dist/style.css';
import '@ingka/helper-text/dist/style.css';
import './styles/_ikea-theme-dark.css';

import { colors } from './styles';

// the font-family is temporary until we have a real header and footer
const Main = styled.main`
  max-width: 906px;
  margin: 0 auto;
  font-family:
    Noto IKEA,
    Noto Sans,
    Roboto,
    Open Sans,
    sans-serif;
  color: ${colors.text.default};
  background: ${colors.background.default};
`;

const PageWrapper = ({
  element,
  props,
}: WrapPageElementBrowserArgs): React.ReactElement => {
  const isTimeslotsToday = props.pageContext.operation === TIMESLOTSTODAY;

  return (
    <>
      <GlobalStyle />
      <Normalize />
      <TextContext paragraphSpacing>
        {isTimeslotsToday ? <div>{element}</div> : <Main>{element}</Main>}
      </TextContext>

      <ErrorModal />
    </>
  );
};

export default PageWrapper;
